import type { ReactElement } from "react";
import { Link } from "react-router-dom";

import { useCompare } from "../contexts/CompareContext";

/**
 * Cycle 9 STORY-802: Floating compare bar.
 *
 * Visible on all pages when user has 1+ products in compare cart.
 * Provides quick access to /compare page.
 */
export function CompareBar(): ReactElement | null {
  const { count, selectedSlugs, removeProduct, clear } = useCompare();

  if (count === 0) return null;

  return (
    <aside
      className="compare-bar"
      role="region"
      aria-label="Корзина сравнения продуктов"
    >
      <div className="compare-bar__count">
        Сравнение: {count}/3
      </div>
      <ul className="compare-bar__list">
        {selectedSlugs.map((slug) => (
          <li key={slug} className="compare-bar__item">
            <span className="compare-bar__slug" title={slug}>{slug}</span>
            <button
              type="button"
              className="compare-bar__remove"
              onClick={() => removeProduct(slug)}
              aria-label={`Убрать ${slug}`}
            >
              ×
            </button>
          </li>
        ))}
      </ul>
      <div className="compare-bar__actions">
        <Link to="/compare" className="btn-primary btn-small">
          Сравнить →
        </Link>
        <button type="button" className="compare-bar__clear" onClick={clear}>
          Очистить
        </button>
      </div>
    </aside>
  );
}
